module.exports = __webpack_public_path__ + "img/2022change.74be38ee.jpg";